<template>
  <BaseForm
    :title="formTitle"
    :formData="fieldData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue'; // Ensure the path is correct
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    fieldId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      fieldData: {
        name: '',
        description: '',
        producer_id: ''
      },
      fields: [
        { model: 'name', label: 'Field Name', required: true, type: 'text' },
        { model: 'description', label: 'Description', type: 'textarea' },
        { model: 'producer_id', label: 'Producer', required: true, type: 'select', optionsUrl: '/api/v1/producer/producers/', labelField: 'name' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.fieldId ? `Edit Field` : 'Add Field';
    },
    submitUrl() {
      return this.fieldId ? `/api/v1/field/fields/${this.fieldId}/` : '/api/v1/field/fields/';
    },
    method() {
      return this.fieldId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.fieldId) {
      this.loadFieldData();
    }
  },
  methods: {
    loadFieldData() {
      axios.get(`/api/v1/field/fields/${this.fieldId}/`).then(response => {
        console.log(response.data);
        this.fieldData = { ...response.data, producer_id: response.data.producer_id };
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Field information saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the field information!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
